import { useEffect } from "react";
import { Navigate, Route, Routes, useNavigate, useSearchParams } from "react-router";
import { AppShell } from "./components/AppShell";
import { AuthGate } from "./components/AuthGate";
import { AnalyticsPage } from "./routes/AnalyticsPage";
import { Conditions } from "./routes/Conditions";
import { Overview } from "./routes/Overview";
import { Placeholder } from "./routes/Placeholder";
import { Projects } from "./routes/Projects";
import { SessionPage } from "./routes/SessionPage";
import { Sessions } from "./routes/Sessions";
import { Settings } from "./routes/Settings";
import { Users } from "./routes/Users";
import { useManifestStore } from "./state/manifestStore";

function DefaultTenantRedirect() {
  const manifest = useManifestStore((s) => s.manifest);
  if (!manifest) return null;
  const first = manifest.tenants[0]?.id;
  return first ? <Navigate to={first} replace /> : <p className="empty">No tenants available.</p>;
}

function RedirectHandler() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const redirect = searchParams.get("redirect");

  useEffect(() => {
    if (redirect) {
      navigate(redirect, { replace: true });
    }
  }, [redirect, navigate]);

  return null;
}

export function App() {
  return (
    <AuthGate>
      <RedirectHandler />
      <Routes>
        <Route path="/" element={<AppShell />}>
          <Route index element={<DefaultTenantRedirect />} />
        </Route>
        <Route path="/:tenant" element={<AppShell />}>
          <Route index element={<Overview />} />
          <Route path="sessions" element={<Sessions />} />
          <Route path="sessions/:sessionId" element={<SessionPage />} />
          <Route path="projects" element={<Projects />} />
          <Route path="users" element={<Users />} />
          <Route path="conditions" element={<Conditions />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route
            path="alerts"
            element={
              <Placeholder
                title="Alerts"
                body="Alerting rules and notification policies arrive in a later milestone."
              />
            }
          />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </AuthGate>
  );
}
